import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders} from '@angular/common/http';
import { log } from 'util';
@Injectable({
  providedIn: 'root'
})
export class PaySalaryService {

  private header :HttpHeaders;
  constructor(private http:HttpClient) {
    this.header = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
   }


   //private link = "https://sentool.bbstvnet.com/index.php";
  private  link='https://smkpay.hybraine.com/bckndpaysal/backend/public/index.php';

   public requerirControllerOM(requete:any): Promise<any>{
    let params="requestParam="+JSON.stringify({requestParam : requete, tokenParam : '4054b4b88528fe6f647341caf069722b04e8fdce3'});
    let link=this.link+"/om-sen/requerirControllerOM";
    return this.http.post(link,params,{headers:this.header}).toPromise().then( res => {console.log(res); return res} ).catch(error => {console.log(error);return 'bad' });
  }
 

}

 